module.exports = __webpack_public_path__ + "img/60.67dd47c2.jpg";